import React from "react";
import { cloneDeep } from "lodash";
import moment from "moment";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import FlatButton from 'material-ui/FlatButton';
// import ChecklistIcon from "material-ui/svg-icons/toggle/radio-button-checked";
import PdfIcon from "material-ui/svg-icons/image/picture-as-pdf";
import excelIcon from '../../assets/excel-icon.ico';

import Form from "./Form";
import ProjectSelect from "../projects/ProjectSelect";
// import ProjectSelect from "./ProjectSelect";


import { CATEGORIES_LIST, CATEGORIES_LIST_HE } from "../../fixtures/categories";
import {FileStackClient} from "../../services/FileStackService";
import uuid from "uuid";

const CATEGORIES_LIST_LOCAL =
  navigator.language.includes('he') ? CATEGORIES_LIST_HE : CATEGORIES_LIST;

class IssueCreator extends React.Component {
  constructor() {
    super();
    this.state = {
      isOpen: false,
      newIssueFiles: {}
    };
    this.categories = Object.values(CATEGORIES_LIST_LOCAL);
  }

  onText = e => this.setState({ nameList: e.target.value });

  preparePost = post => {
    const { issue, members } = this.props;

    const p = cloneDeep(post);

    if (p.cost === "") p.cost = 0;

    if (p.schedule === "") p.schedule = 0;

    if (p.categories === "-1") {
      delete p.categories;
    }

    if (p.categories && !Array.isArray(p.categories)) {
      p.categories = [p.categories];
    }

    if (!p.priority) p.priority = { key: 0, title: 'task' };

    if (Array.isArray(p.tagged)) {
      p.tagged = p.tagged.reduce((acc, item) => {
        acc[item] = members[item];
        return acc;
      }, {});
    }

    if (moment.isMoment(p.dueDate)) p.dueDate = p.dueDate.toISOString();

    const data = { ...issue, ...p };

    if (p.images) {
      data.images = p.images;
    }

    return { ...data };
  };

  onAdd = post => {
    const { onAdd } = this.props;
    const newPost = this.preparePost(post);

    onAdd(newPost);
    this.onClose();
  };
  onClose = () => {
    this.props.onClose();
    this.setState({ isOpen: false });
  };

  onDelete = () => {
    const { onDelete, issue, onClose } = this.props;
    onDelete(issue);
    this.setState({ isOpen: false });
    this.props.onClose();
  };

  onEdit = post => {
    const { onEdit } = this.props;
    const newPost = this.preparePost(post);
    onEdit(newPost);
    // const { nameList } = this.state;
    // onEdit({ id, data: { title: nameList } });
    this.onClose();
  };

  // componentWillReceiveProps({ issue }) {
  //     if (issue) {
  //         this.setState({ nameList: issue.title });
  //     }
  // }

  render() {
    const { isOpen, newIssueFiles } = this.state;
    const { issue, members, initiateReportMode, history, locations } = this.props;
    const onConfirm = !!issue ? this.onEdit : this.onAdd;
    const text = !!issue ? "Done" : "Add";
    const EXCEL = 'xlsx';
    const PDF = 'pdf';

    console.log('issue', issue);

    return (
      <React.Fragment>
        <Dialog
          onClose={this.onClose}
          open={isOpen || !!issue || false}
          fullWidth={true}
          maxWidth="md"
        >
          <DialogTitle>{text} Issue</DialogTitle>
          <Form
            members={members}
            {...issue}
            newIssueFiles={newIssueFiles}
            onConfirm={onConfirm}
            onClose={this.onClose}
            onDelete={this.onDelete}
            onStartUpload={this._handleUpload}
            locations={locations}
          />
        </Dialog>
        <ProjectSelect history={history} />

        <FlatButton
          label={
            <img style={{marginTop: 5, width: 25, height: 25 }} src={excelIcon} alt="Excel Icon" />
          }
          onClick={() => initiateReportMode(EXCEL)}
          style={{
            // marginBottom: "25px",
            position: "fixed",
            top: 20,
            right: 270,
            zIndex: 1300
          }}
        />
        <FlatButton
          label={
            <PdfIcon style={{marginTop: 5}} />
          }
          onClick={() => initiateReportMode(PDF)}
          style={{
            // marginBottom: "25px",
            position: "fixed",
            top: 20,
            right: 200,
            zIndex: 1300
          }}
        />
        <FlatButton
          label="add new Issue"
          onClick={() => {
            this.setState({ isOpen: true });
          }}
          labelStyle={{ color: "#fff" }}
          hoverColor={"#77c723"}
          backgroundColor={"#6da92e"}
          style={{
            marginBottom: "25px",
            position: "fixed",
            top: 20,
            right: 50,
            zIndex: 1300
          }}
        />
      </React.Fragment>
    );
  }
}

export default IssueCreator;
